export default __webpack_public_path__ + "513ee2348ec5a137f4ff52f3b6099c1e.svg";